module.exports = __webpack_public_path__ + "public/files/img/up.ce049e00.gif";